export const REVIEW_CHANNELS = {
  N_A: 'N/A',
  GOOGLE: 'GOOGLE',
  FACEBOOK: 'FACEBOOK',
  YELP: 'YELP',
  TIRE_RACK: 'TIRE_RACK',
  OTHER: 'OTHER',
} as const

export const REVIEW_CHANNELS_ARRAY = Object.values(REVIEW_CHANNELS)

export const INCIDENT_TYPES = {
  INCIDENT: 'INCIDENT',
  ACCIDENT: 'ACCIDENT',
  INJURY: 'INJURY',
  SURVEY: 'SURVEY',
} as const

export const INCIDENT_TYPES_ARRAY = Object.values(INCIDENT_TYPES)

export const SEVERITY_OF_INCIDENT = {
  N_A: 'N/A',
  ONE: '1',
  TWO: '2',
  THREE: '3',
  FOUR: '4',
  FIVE: '5',
} as const

export const SEVERITY_OF_INCIDENT_ARRAY = Object.values(SEVERITY_OF_INCIDENT)

export const WHEEL_OFF_REASONS = {
  IMPROPER_TORQUE: 'IMPROPER_TORQUE',
  LUG_NUT_FAILURE: 'LUG_NUT_FAILURE',
  STUD_FAILURE: 'STUD_FAILURE',
  TECHNICIAN_ERROR: 'TECHNICIAN_ERROR',
  EQUIPMENT_FAILURE: 'EQUIPMENT_FAILURE',
  UNKNOWN: 'UNKNOWN',
  OTHER: 'OTHER',
} as const

export const WHEEL_OFF_REASONS_ARRAY = Object.values(WHEEL_OFF_REASONS)

export const INCIDENT_REPORT_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  CLOSED: 'CLOSED',
} as const

export const INCIDENT_REPORT_STATUS_ARRAY = Object.values(INCIDENT_REPORT_STATUS)

export interface IAccidentData {
  driverName?: string
  cityState?: string
  numberOfInjuries?: number
  numberOfFatalities?: number
  isVehicleTowed?: boolean
  isHazmatRelease?: boolean
  isDriverCitation?: boolean
}
